import { Dialog, Button, useTheme, useStyles } from '@archipro-design/aria';
import { useState } from 'react';
import { useFetcher } from '@remix-run/react';
import DesignBoardConfirmationModal from './DesignBoardConfirmationModal';
import * as S from './DesignBoardConfirmation.style';

interface LeaveButtonProps {
    handleLeave?: () => void;
    designBoardId: number;
    boardTitle: string;
}

const LeaveBoard = ({
    handleLeave,
    designBoardId,
    boardTitle,
}: LeaveButtonProps) => {
    const [leaveDialogOpen, setLeaveDialogOpen] = useState(false);

    const { css } = useStyles();
    const theme = useTheme();
    const fetcher = useFetcher<never>();

    const darkOutlinedButtonBorderNormal = `1px solid ${theme.siteVariables.colors.charcoal[250]}`;

    const onLeave = () => {
        const idString = designBoardId.toString();
        const data = { designBoardId: idString, boardTitle: boardTitle };
        fetcher.submit(data, {
            method: 'post',
            action: '/remix-api/design-board/leave-design-board',
        });
    };

    const handleLeaveBoard = handleLeave || onLeave;

    return (
        <>
            <Dialog
                open={leaveDialogOpen}
                onCancel={() => setLeaveDialogOpen(false)}
                content={{
                    content: (
                        <DesignBoardConfirmationModal
                            headerText="Leave board"
                            bodyText="Are you sure you would like to leave this board?"
                            confirmationText="LEAVE"
                            onConfirm={() => handleLeaveBoard()}
                            onCancel={() => setLeaveDialogOpen(false)}
                        />
                    ),
                    className: css(S.DesignBoardModalContainer),
                }}
                variables={{
                    rootBorderRadius: 0,
                    rootWidth: 'fit-content',
                    overlayBackdrop: 'blur(2px)',
                    overlayBackground: 'rgba(0, 0, 0, 0.2) !important',
                }}
                footer={null}
                header={null}
            />
            <Button
                color="dark"
                variant="outlined"
                onClick={() => setLeaveDialogOpen(true)}
                variables={{
                    buttonPadding: 16,
                    iconPadding: 4,
                    darkOutlinedButtonBorderNormal,
                }}
            >
                LEAVE BOARD
            </Button>
        </>
    );
};

export default LeaveBoard;
